<div class="okta-container">
  <div class="row okta-wrapper">
    <div class="okta-form-row">
      <div class="row logo-holder">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
          <img class="app-logo" src="/assets/images/{{websiteName}}/LogoNew.png" alt="" />
        </div>
      </div>
      <div class="row box-container">
        <div class="form-info">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="has-error okta-error">
              <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
              <p class="show-message">
                Your temporary password has expired and must be changed. Please enter a new password.
              </p>
            </div>
            <form #activateForm="ngForm" novalidate class="form-info account-setup-form" (ngSubmit)="onChangePassword()">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="has-error okta-error" *ngIf="serverErrors.errorMessage">
                  <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                  <p class="show-message">
                    <span title="{{serverErrors.errorMessage}}">{{serverErrors.errorMessage}}</span>
                  </p>
                </div>
                <ul class="form-grid">
                  <li class="activate-control">
                    <mat-form-field>
                      <input id="new-password" matInput name="newpassword" type="password" required #newpassword="ngModel" placeholder="Enter New Password" [(ngModel)]="change.newPassword"
                        parValidateEqual="confirmPassword" reverse="true" [pattern]="validation.passwordRegex" parAutoFocus>
                      <mat-error *ngIf="newpassword.errors?.required">New password is required.</mat-error>
                    </mat-form-field>
                  </li>
                  <li class="activate-control">
                    <div>
                      <mat-form-field>
                        <input id="confirm-password" matInput name="confirmPassword" type="password" required #confirmPassword="ngModel" placeholder="Confirm New Password"
                          parValidateEqual="newpassword" [(ngModel)]="change.confirmPassword" [pattern]="validation.passwordRegex">
                        <mat-error *ngIf="confirmPassword.errors?.required">Confirm password is required.</mat-error>
                        <mat-error *ngIf="confirmPassword.errors?.validateEqual">New password and confirm password do not match.</mat-error>
                      </mat-form-field>
                    </div>
                  </li>
                  <li class="password-hint">
                    <p *ngIf="!newpassword.errors?.pattern && !confirmPassword.errors?.pattern">{{messages.passwordHint}}</p>
                    <div *ngIf="newpassword.errors?.pattern || confirmPassword.errors?.pattern" class="has-error okta-error">
                      <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                      <p class="show-message">
                        <span>{{messages.passwordHint}}</span>
                      </p>
                    </div>
                  </li>
                  <li class="action-button">
                    <button id="btn-submit" type="submit" [disabled]="activateForm.invalid" mat-raised-button color="accent">Change Password</button>
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>